import { render, staticRenderFns } from "./ele6.vue?vue&type=template&id=2ba7a0ab&scoped=true"
import script from "./ele6.vue?vue&type=script&lang=js"
export * from "./ele6.vue?vue&type=script&lang=js"
import style0 from "./ele6.vue?vue&type=style&index=0&id=2ba7a0ab&prod&lang=scss"
import style1 from "./ele6.vue?vue&type=style&index=1&id=2ba7a0ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba7a0ab",
  null
  
)

export default component.exports